<template>
	<v-tabs
		background-color="secondary"
		slider-color="primary"
		grow
		icons-and-text
		elevation='10'
	>
		<template v-for="item in items">
			<v-tab :key="`tab-${item.title}`">
				{{ item.title }}
				<v-icon left>{{ item.icon }}</v-icon>
			</v-tab>
			<v-tab-item :key="`content-${item.title}`">
				<v-card-text class='pa-8'>
					<section class="mb-10">
						<h2 class="text-h4 mb-4" v-text="item.title" />

						<v-card v-if="item.text">
							<v-card-text v-html="item.text" />
						</v-card>
					</section>
					<section class="mb-10">
						<v-row>
							<v-col v-for="file in item.files" :key="file.title" cols="3" sm='6' md='4' lg='3'>
								<a :href="file.path" target="_blank">
									<MediaItem v-bind="file" />
								</a>
							</v-col>
						</v-row>
					</section>
				</v-card-text>
			</v-tab-item>
		</template>
	</v-tabs>
</template>

<script>
import MediaItem from './n-items/MediaItem'
export default {
	name: 'MediaTabs',
	components: {
		MediaItem,
	},
	props: {
		items: Array,
	},
}
</script>

<style lang="scss" scoped>
a {
	text-decoration: none;
}
</style>